import { LoginModuleState } from ".";
import { LoginResult } from "@futuri/cloudsso-client/src/client/types/api";

export const SET_PORTAL_DATA = async (
  state: LoginModuleState,
  portalData: LoginResult
) => {
  state.portalData = portalData;
};

export const SET_STATION = (state: LoginModuleState, station: string) => {
  state.station = station;
};
